(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    const tabButtons = document.querySelectorAll('.tab-button:not(.skewed)'); // Ignora o botão skewed
    const collectionContainers = document.querySelectorAll('.collection-container');
    

    const firstButton = document.querySelector('.tab-button.skewed');
    if (firstButton && !firstButton.querySelector('span')) {
      const text = firstButton.textContent;
      firstButton.innerHTML = `<span>${text}</span>`;
    }
    

    if (firstButton) {
      firstButton.style.pointerEvents = 'none'; 
      firstButton.disabled = true; 
    }
    

    const scrollToActiveCollection = (collectionElement) => {
      if (collectionElement) {
        const topOffset = collectionElement.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({
          top: topOffset,
          behavior: 'smooth'
        });
      }
    };
    

    const firstActiveCollection = document.querySelector('.collection-container.active');
    if (firstActiveCollection) {
      setTimeout(() => {
        scrollToActiveCollection(firstActiveCollection);
      }, 100);
    }
    
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const collectionHandle = this.getAttribute('data-collection');
        
       
        tabButtons.forEach(btn => {
          btn.classList.remove('active');
          
          if (btn.querySelector('span')) {
            btn.textContent = btn.querySelector('span').textContent;
          }
        });
        
       
        collectionContainers.forEach(container => {
          container.classList.remove('active');
        });
        
       
        this.classList.add('active');
        
    
        const targetCollection = document.querySelector(`.collection-container[data-collection="${collectionHandle}"]`);
        if (targetCollection) {
          targetCollection.classList.add('active');
          
  
          setupScrollButtons();
          
      
          scrollToActiveCollection(targetCollection);
        }
      });
    });
    
   
    setupScrollButtons();
    
    
    const productForms = document.querySelectorAll('.product-form');
    
    productForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(item => {
      
          window.location.href = '/cart';
        })
        .catch(error => {
          console.error('Erro ao adicionar ao carrinho:', error);
        });
      });
    });
    
    function setupScrollButtons() {
      
      const scrollContainers = document.querySelectorAll('.collection-container.active .products-scroll');
      
      scrollContainers.forEach(container => {
        const leftButton = container.parentElement.querySelector('.scroll-left');
        const rightButton = container.parentElement.querySelector('.scroll-right');
        
        if (leftButton && rightButton) {
       
          const newLeftButton = leftButton.cloneNode(true);
          const newRightButton = rightButton.cloneNode(true);
          
          leftButton.parentNode.replaceChild(newLeftButton, leftButton);
          rightButton.parentNode.replaceChild(newRightButton, rightButton);
          
          
          newLeftButton.addEventListener('click', () => {
            container.scrollBy({ left: -300, behavior: 'smooth' });
          });
          
 
          newRightButton.addEventListener('click', () => {
            container.scrollBy({ left: 300, behavior: 'smooth' });
          });
          
         
          const checkScrollButtons = () => {
            newLeftButton.style.opacity = container.scrollLeft > 0 ? '1' : '0.5';
            newRightButton.style.opacity = 
              container.scrollLeft < (container.scrollWidth - container.clientWidth - 10) ? '1' : '0.5';
          };
          
          
          checkScrollButtons();
          
        
          container.addEventListener('scroll', checkScrollButtons);
        }
      });
    }
    
   
    const productImages = document.querySelectorAll('.product-card-img');
    productImages.forEach(img => {
      img.onload = function() {
        this.classList.add('loaded');
      };
    });
    

    function equalizeCardHeights() {
      const productCards = document.querySelectorAll('.collection-container.active .product-card');
      let maxHeight = 0;
      
     
      productCards.forEach(card => {
        card.style.height = 'auto';
      });
      

      productCards.forEach(card => {
        const height = card.offsetHeight;
        if (height > maxHeight) {
          maxHeight = height;
        }
      });
      
 
      if (maxHeight > 0) {
        productCards.forEach(card => {
          card.style.height = `${maxHeight}px`;
        });
      }
    }
    
    
    function debounce(func, wait) {
      let timeout;
      return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    }
    

    window.addEventListener('load', equalizeCardHeights);
    window.addEventListener('resize', debounce(() => {
      setupScrollButtons();
      equalizeCardHeights();
    }, 250));
    
   
    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        setTimeout(equalizeCardHeights, 100); 
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
